import { render, staticRenderFns } from "./ProcessInstances.vue?vue&type=template&id=4e5389fa&scoped=true"
import script from "./ProcessInstances.vue?vue&type=script&lang=js"
export * from "./ProcessInstances.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstances.vue?vue&type=style&index=0&id=4e5389fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5389fa",
  null
  
)

export default component.exports